import React from 'react'

const LightningIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="lightningGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 220, 100, 1)" />
          <stop offset="100%" stopColor="rgba(255, 180, 60, 1)" />
        </linearGradient>
        <filter id="lightningGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Lightning bolt */}
      <path 
        d="M13 2L3 14h8l-1 8 10-12h-8l1-8z"
        fill="url(#lightningGradient)"
        filter="url(#lightningGlow)"
      />
      
      {/* Inner highlight */}
      <path 
        d="M11 4L6 14h5l-1 4 6-8h-5l1-6z"
        fill="rgba(255, 255, 255, 0.4)"
      />
    </svg>
  )
}

export default LightningIcon
